import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Button, InputGroup, FormControl, Alert } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { AuthInterceptor } from "../services/AuthInterceptor.Service";
import Toaster from "../components/Commaon/Toaster";
import Spinnerr from "../components/Commaon/Spinner";
import { getDefaultAccessiblePath } from "../utils/menuAccess";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [snack, setSnack] = useState(null);
  const [loading, setLoading] = useState(false);

 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const response = await AuthInterceptor("/admin/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });

    const data = response.data;

    if (response.status === 200 && data.s === 200) {
      setLoading(false);
      setSnack({ message: data.m, type: "success" });
      localStorage.setItem("token", data.r.token);
      localStorage.setItem("user", JSON.stringify(data.r));
      navigate(getDefaultAccessiblePath(data.r), { replace: true });
    } else {
      setLoading(false);
      const msg = data.m || data.message || "Login failed";
      setSnack({ message: msg, type: "error" });
      setError(msg);
    }
  } catch (err) {
    setLoading(false);
    setSnack({ message: "Network error. Try again!", type: "error" });
    setError("Network error. Try again!");
    console.error("Login error:", err);
  }
};


  return (
    <>
      <Spinnerr show={loading} />
      {snack && (
        <Toaster
          notification={{ message: snack.message, type: snack.type }}
          onClose={() => setSnack(null)}
        />
      )}

      <div
        style={{ width: "100%", maxWidth: "400px" }}
        className="mx-auto mt-5 p-4 border rounded"
      >
        <h2 className="mb-4 text-center">Welcome to MedZeo Lab! 👋</h2>
        <p className="text-center mb-4">Please sign-in to your admin account</p>

        {error && <Alert variant="danger">{error}</Alert>}

        <Form onSubmit={handleSubmit}>
          {/* Email */}
          <Form.Group className="mb-3" controlId="formEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>

          {/* Password */}
          <Form.Group className="mb-3" controlId="formPassword">
            <Form.Label>Password</Form.Label>
            <InputGroup>
              <FormControl
                type={showPassword ? "text" : "password"}
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <Button
                variant="outline-secondary"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </Button>
            </InputGroup>
          </Form.Group>

          {/* Remember & Forgot */}
          <div className="d-flex justify-content-center align-items-center mb-3">
            <Link to="/forgot-password">Forgot Password?</Link>
          </div>

          {/* Submit */}
          <Button type="submit" className="w-100 mb-3">
            Login
          </Button>
        </Form>
      </div>
    </>
  );
};

export default Login;
